import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {AlertModule} from "ngx-bootstrap/alert";
import {ModalDialogModule} from "ngx-modal-dialog";
import {ModalModule} from "ngx-bootstrap/modal";
import {SiteServices} from "../../services/siteservices";
import {EnvironmentServices} from "../../services/evironment.service";
import {ArchieComponent} from "./archie.main";

@NgModule({
    declarations: [ArchieComponent],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        AlertModule.forRoot(),
        ModalDialogModule.forRoot(),
        ModalModule.forRoot()
    ],
    providers: [SiteServices, EnvironmentServices],

    bootstrap: [ArchieComponent],
})
export class ArchieModule {}